// extracted by mini-css-extract-plugin
export default {"removePhoto":"RunShareComposer_removePhoto__kguCB"};